<script>
import axios from 'axios';
import router from '@/router';
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import Swal from 'sweetalert2';
import { required, sameAs, email } from 'vuelidate/lib/validators';
export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { Header, Footer },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			userData: JSON.parse(localStorage.getItem('web_user')),
			addReferencesForm: {
				user_type_id: '',
				user_type: 'mentor',
				name: '',
				telephone: '',
				email: '',
				confirm_email: '',
				relationship: '',
				organization: '',
				title: '',
				status: '1',
			},
			typeSubmit: false,
			isEmpty: false,
		};
	},
	validations: {
		addReferencesForm: {
			name: { required },
			telephone: { required },
			email: { required, email },
			confirm_email: { required, sameAsEmail: sameAs('email') },
			relationship: { required },
		},
	},
	mounted() {
		this.getReferences();
	},
	methods: {
		addReferences() {
			this.typeSubmit = true;
			this.$v.$touch();
			if (this.$v.$invalid) {
				return;
			}

			let userData = JSON.parse(localStorage.getItem('web_user'));
			if (!userData || !userData.token) {
				return;
			}

			let config = { headers: { Authorization: 'Bearer ' + userData.token } };
			this.addReferencesForm.user_type_id = parseInt(userData['user_type_id']);
			axios
				.post('user/references', this.addReferencesForm, config)
				.then((res) => {
					this.typeSubmit = false;
					if (res.status == 200) {
						if (this.userData.user_type_id === 4 && this.userData.is_invited) {
							router.push({ name: 'mentor-review-application' });
						}
					}
				})
				.catch(async (err) => {
					this.typeSubmit = false;
					if (err.response) {
						await Swal.fire({
							title: 'Error!',
							text: err?.response?.data?.error?.message,
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
					}
				});
		},
		// Getting Current User References
		getReferences() {
			var userData = JSON.parse(localStorage.getItem('web_user'));
			var config = {
				headers: { Authorization: 'Bearer ' + userData.token },
			};
			if (userData.token) {
				axios
					.get('user/references/' + userData['id'] + '?user_type_id=' + userData['user_type_id'], config)
					.then((res) => {
						if (res.data.response) {
							this.addReferencesForm = { ...this.addReferencesForm, ...res.data.response };
							this.addReferencesForm.confirm_email = this.addReferencesForm.email ? this.addReferencesForm.email : '';
						}
					})
					.catch((err) => {
						if (err.response) {
							if (err.response.status == 404) {
								console.log('No Record Found');
							}
							if (err.response.status == 401) {
								this.logout();
							}
						}
					});
			}
		},
		backgroundCheck() {
			router.push({ name: 'mentor-background-check' });
		},
		contact() {
			router.push({ name: 'contact' });
		},
	},
};
</script>

<template>
	<div>
		<Header></Header>
		<div id="main-title" class="secondary">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-6 align-self-center">
						<h3 class="title">Become a Mentor</h3>
					</div>
					<div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
						<p class="need-help">Need Help ? <a @click="contact" href="javascript:">Contact Us</a></p>
					</div>
				</div>
			</div>
		</div>
		<div id="create-account">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-12">
						<div class="progress-container">
							<div class="progress-box">1</div>
							<div class="progress-box active">2</div>
						</div>
					</div>
				</div>
				<form @submit.prevent="addReferences" class="custom-form">
					<div class="row">
						<div class="col-12 mb-5">
							<h3 class="main-title">Character Reference</h3>
						</div>

						<div class="col-12 mb-5">
							<span class="font-size-16 d-inline-block mb-2">
								All mentors working with our clients must be able to model a mature Christian lifestyle. We are especially interested in your ability to maintain professional boundaries with our clients. Because of the nature of our program, and the large amount of responsibility given to our
								mentors, we are requesting that you provide the name of someone that can serve as a character reference on your behalf. Whether it is a pastor, friend, or colleague, please select someone that has known you long enough to speak to your character and abilities.
								<b>Your character reference may NOT be someone who is related to you or to whom you are dating or engaged.</b>
								This character reference is confidential; MnTC will not be able to share the results with you.
							</span>
						</div>

						<div class="col-12 mb-5">
							<span class="text-danger font-size-18" v-if="isEmpty">All the fields are required </span>
						</div>
					</div>

					<div class="row">
						<div class="col-12 col-md-4 mb-4">
							<div class="mb-3">
								<input v-model="addReferencesForm.name" type="text" placeholder="Enter first and last name *" class="form-control" />
							</div>
						</div>
						<div class="col-12 col-md-4 mb-4">
							<div class="mb-3">
								<input v-mask="'###-###-####'" v-model="addReferencesForm.telephone" type="text" placeholder="Enter Telephone *" class="form-control" />
							</div>
						</div>
						<div class="col-12 col-md-4 mb-4">
							<div class="mb-3">
								<input v-model="addReferencesForm.email" type="text" placeholder="Enter Email Address *" class="form-control" />
							</div>
						</div>

						<div class="col-12 col-md-4 mb-4">
							<div class="mb-3">
								<input v-model="addReferencesForm.confirm_email" type="text" placeholder="Confirm Email *" class="form-control" />
							</div>
						</div>

						<div class="col-12 col-md-4 mb-4">
							<div class="mb-3">
								<input v-model="addReferencesForm.relationship" type="text" placeholder="Enter Relationship *" class="form-control" />
								<small class="d-inline-block ms-4 mt-2 font-size-14">How do you know this person?</small>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-12"></div>
					</div>
					<div class="row">
						<div class="mb-5 col-4 text-md-start"></div>
						<div class="mb-4 col-8 text-center text-md-end">
							<b-button type="button" @click="backgroundCheck" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Back to Background Check</b-button>
							<b-button type="button" @click="addReferences" variant="custom">Review Application<i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
